import React from 'react';
import { Button } from '@ditioas/web-ui';

import FullscreenMessageWrapper from 'components/fullscreen-message-wrapper';
import LayoutTitle from 'components/layout/LayoutTitle';

interface Props {
  title?: string;
  heading: string;
  children: React.ReactNode;
  buttonHref?: string;
  onButtonClick?: () => void;
  buttonText: string;
}

const ErrorMessageScreen: React.FC<Props> = ({
  title,
  heading,
  children,
  buttonHref,
  onButtonClick,
  buttonText,
}) => (
  <FullscreenMessageWrapper>
    <LayoutTitle>{title || heading}</LayoutTitle>
    <h2 className="heading-lg">{heading}</h2>
    <p className="body-sm">{children}</p>
    {buttonHref ? (
      <Button data-testid="components.error-message-screen.link-button" asChild>
        <a href={buttonHref}>{buttonText}</a>
      </Button>
    ) : (
      <Button
        data-testid="components.error-message-screen.action"
        type="button"
        onClick={onButtonClick}
      >
        {buttonText}
      </Button>
    )}
  </FullscreenMessageWrapper>
);

export default ErrorMessageScreen;
